import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../core/layout.service';
import {SessionService} from "../../../../shared/services/session/session.service";
import {SessionQuery} from "../../../../shared/services/session/session.query";
import {SessionStore} from "../../../../shared/services/session/session.store";

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  toolbarButtonMarginClass = 'ms-1 ms-lg-3';
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px';
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px';
  toolbarButtonIconSizeClass = 'svg-icon-1';
  headerLeft: string = 'menu';

  profileImage: string | null;

  constructor(private layout: LayoutService, private sessionStore: SessionStore, private sessionQuery: SessionQuery) {}

  ngOnInit(): void {
    this.headerLeft = this.layout.getProp('header.left') as string;
    this.profileImage = this.sessionQuery.getValue().profileImage;
    this.sessionStore.currentProfileImage.subscribe(res => {
      this.profileImage = this.sessionQuery.getValue().profileImage;
    })
  }
}
